import { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { translate } from "./index";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ lang, children }) => {
  const location = useLocation();

  const value = useMemo(() => {
    const t = (path) => translate(lang, path);
    const lp = (path) => `${lang === "pt" ? "" : `/${lang}`}${path === "/" ? "" : path}` || "/";
    const switchPath = (target) => {
      const stripped = location.pathname.replace(/^\/(en|es|fr)(?=\/|$)/, "") || "/";
      const rest = stripped === "/" ? "" : stripped;
      return `${target === "pt" ? "" : `/${target}`}${rest}` || "/";
    };
    return { lang, t, lp, switchPath };
  }, [lang, location.pathname]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
